/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Experience } from './';
import {
    ExperienceFromJSON,
    ExperienceFromJSONTyped,
    ExperienceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrderedExperience
 */
export interface OrderedExperience {
    /**
     * 
     * @type {Experience}
     * @memberof OrderedExperience
     */
    experience: Experience;
    /**
     * 
     * @type {number}
     * @memberof OrderedExperience
     */
    order: number;
}

/**
 * Check if a given object implements the OrderedExperience interface.
 */
export function instanceOfOrderedExperience(value: object): value is OrderedExperience {
    if (!('experience' in value) || value['experience'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function OrderedExperienceFromJSON(json: any): OrderedExperience {
    return OrderedExperienceFromJSONTyped(json, false);
}

export function OrderedExperienceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderedExperience {
    if (json == null) {
        return json;
    }
    return {
        
        'experience': ExperienceFromJSON(json['experience']),
        'order': json['order'],
    };
}

export function OrderedExperienceToJSON(value?: OrderedExperience | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'experience': ExperienceToJSON(value['experience']),
        'order': value['order'],
    };
}

